import { EncTotals } from './Encodings/Totals';
import { EncFieldGroup, EncFieldGroupType } from './Encodings/EncFieldGroup';
import { EMPTY_MARKS } from './Encodings/Marks';
import { EncSort } from './Encodings/SortEncoding';
export const EMPTY_ENCODING = {
    marks: {
        channel: '*',
        properties: {
            ...EMPTY_MARKS,
        },
        series: [],
    },
    row: [],
    column: [],
    x: [],
    x2: [],
    y: [],
    y2: [],
    sorts: [],
    filter: [],
    value: [],
    totals: {
        ...EncTotals.make(),
    },
};
export * from './Encodings/BaseField';
export * from './Encodings/Marks';
export { EncSort, EncFieldGroup, EncFieldGroupType, };
export * from './Encodings/EncFilter';
export * from './Encodings/Series';
export * from './Encodings/Channel';
